import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RideActionsComponent } from '../ride-actions/ride-actions.component';

@Component({
  selector: 'app-ride-actions-dialog',
  standalone: true,
  imports: [RideActionsComponent, ButtonComponent],
  templateUrl: './ride-actions-dialog.component.html',
  styleUrl: './ride-actions-dialog.component.scss',
})
export class RideActionsDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
}
